import App from "../../services/App/App.js";
import ModelBody from "./VenModel_Body.js";

export default {
  /*** related ***/

  /*** property ***/

  /*** method ***/

  setDetailsByData(userData, vendorData) {
    userData.ID = vendorData.ID;
    // user input
    userData.Name = App.In.getString(vendorData.Name);
    userData.Alias = App.In.getString(vendorData.Alias);
    userData.DaysDueDate = App.In.getInteger(vendorData.DaysDueDate);
    userData.Mobile = App.In.getString(vendorData.Mobile);
    userData.Phone = App.In.getString(vendorData.Phone);
    userData.Email = App.In.getString(vendorData.Email);
    userData.Comment = App.In.getString(vendorData.Comment);
  },
  setAddressesByData(userAddressList, addressList) {
    App.Array.truncate(userAddressList);

    for (const address of addressList) {
      let userAddress = ModelBody.createAddress();
      this.setAddressesByData_setAddress(userAddress, address);
      userAddressList.push(userAddress);
    }
  },
  setAddressesByData_setAddress(userAddress, addressData) {
    userAddress.ID = addressData.ID;
    // user input
    userAddress.Name = App.In.getString(addressData.Name);
    userAddress.Address = App.In.getString(addressData.Address);
    userAddress.ContactName = App.In.getString(addressData.ContactName);
    userAddress.ContactMobile = App.In.getString(addressData.ContactMobile);
    userAddress.ContactPhone = App.In.getString(addressData.ContactPhone);
    userAddress.ContactEmail = App.In.getString(addressData.ContactEmail);
  }
}